import formName from 'constants/formName'
import { actions } from 'data'
import { notifyError } from 'data/App/sagas'
import { TOtpConfigType, TwoFactorFormType } from 'data/types'
import { call, put } from 'redux-saga/effects'
import { displayBackupCodes } from 'services/api/user'
import { Response } from 'utils/fetchApi'

import { goToStep } from './common'

export default function* displayCodesStep() {
  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))
  yield call(goToStep, 'generatenewcodes')
}

export const displayCodesWorker = function* (form: TwoFactorFormType) {
  yield put(actions.auth.setTotpConfig({ backupCodes: [], seed: '' }))

  const data: Response<TOtpConfigType> = yield call(displayBackupCodes, form)

  if (!data.ok && data.error.status === 401) {
    yield call(goToStep, 'verifytwofactor')
  }

  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))

  if (!data.ok) {
    if (data.error.status === 401) {
      return
    }
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(actions.auth.setTotpConfig(data.response))

  yield call(goToStep, 'displaycodes')
}
